import { AuthenticationService, JWTToken } from '@philips-emr/tws-core/lib/services';

import TokenConstants from '../constants/token-constants';

interface ClaimValue {
  nrSeqPlsUser: string;
  nrSeqWSuiteUser: string;
  defaultProvider: string;
  ssoLogin: string;
  ssoLogoutRoute: string;
}

export class TokenUtils {

  private static getToken(): JWTToken {
    const token = AuthenticationService.getJWTToken();
    if (!token) {
      throw 'token-utils: [JWTToken] is not defined';
    }
    return token;
  }

  private static getClaim(name: TokenConstants): string {
    return this.getToken().claims[name] as string;
  }

  static getValues(): ClaimValue {
    return {
      nrSeqPlsUser: this.getClaim(TokenConstants.NR_SEQ_PLS_USER),
      nrSeqWSuiteUser: this.getClaim(TokenConstants.NR_SEQ_WSUITE_USER),
      defaultProvider: this.getClaim(TokenConstants.DEFAULT_PROVIDER),
      ssoLogin: this.getClaim(TokenConstants.EXT_SSO_LOGIN),
      ssoLogoutRoute: this.getClaim(TokenConstants.EXT_SSO_LOGOUT_ROUTE),
    };
  }

}
